export const getNotificationTemplate = (status, appData) => {
    const appName = appData.name || appData.applicationName || 'Application';
    const appId = appData.id || appData.applicationId;
    const userName = appData.userName || appData.user_name || 'User';
    const submittedDate = appData.submittedDate || appData.updated_at || new Date().toLocaleDateString();

    // Status can be numeric or string
    let stateStr = String(status).toLowerCase();

    let discrepanciesText = '';
    if (appData.discrepancies) {
        if (typeof appData.discrepancies === 'object') {
            const reasons = [];
            for (const key in appData.discrepancies) {
                const item = appData.discrepancies[key];
                if (item && item.value) {
                    reasons.push(item.value);
                }
            }
            if (reasons.length > 0) {
                discrepanciesText = reasons.join(', ');
            } else {
                try {
                    discrepanciesText = JSON.stringify(appData.discrepancies);
                } catch (e) {
                    discrepanciesText = String(appData.discrepancies);
                }
            }
        } else {
            discrepanciesText = String(appData.discrepancies);
        }
    }

    const templates = {
        'pending': {
            subject: `Application Submitted: ${appName} (GB-${appId})`,
            message: `Your application ${appName} (GB-${appId}) has been submitted successfully.`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #2c3e50;">Application Submitted</h2>
                    <p>Dear ${userName},</p>
                    <p>Your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) has been submitted successfully.</p>
                    <p>Our team will review your application and provide updates shortly.</p>
                    <p>Please log in to your dashboard to track the progress.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        },
        'in_process': {
            subject: `Application In Process: ${appName} (GB-${appId})`,
            message: `Your application ${appName} (GB-${appId}) is now in process.`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #2c3e50;">Application In Process</h2>
                    <p>Dear ${userName},</p>
                    <p>Your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) is now being processed by our team.</p>
                    <p>We will notify you of any further updates or requirements.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        },
        'approved': {
            subject: `Application Approved: ${appName} (GB-${appId})`,
            message: `Congratulations! Your application ${appName} (GB-${appId}) has been approved.`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #28a745;">Application Approved</h2>
                    <p>Dear ${userName},</p>
                    <p>We are pleased to inform you that your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) has been <strong>approved</strong>.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        },
        'rejected': {
            subject: `Application Rejected: ${appName} (GB-${appId})`,
            message: `Your application ${appName} (GB-${appId}) has been rejected.`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #dc3545;">Application Rejected</h2>
                    <p>Dear ${userName},</p>
                    <p>We regret to inform you that your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) has been <strong>rejected</strong>.</p>
                    ${discrepanciesText ? `<p><strong>Reason/Discrepancies:</strong> ${discrepanciesText}</p>` : ''}
                    <p>Please log in to your dashboard for more details.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        },
        'discrepancies': {
            subject: `Discrepancies in Application: ${appName} (GB-${appId})`,
            message: `Discrepancies have been found in your application ${appName} (GB-${appId}).`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #ffc107;">Action Required: Discrepancies Found</h2>
                    <p>Dear ${userName},</p>
                    <p>Our review team has found some discrepancies in your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>).</p>
                    <p><strong>Details:</strong> ${discrepanciesText || 'Please check the application for details.'}</p>
                    <p>Please log in to your dashboard to address these issues.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        },
        'renewal': {
            subject: `Renewal Reminder: ${appName} (GB-${appId})`,
            message: `Reminder: application ${appName} (GB-${appId}) is due for renewal${appData.dueDate ? ` on ${appData.dueDate}` : ""}.`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #17a2b8;">Renewal Reminder</h2>
                    <p>Dear ${userName},</p>
                    <p>This is a reminder that your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) is due for renewal${appData.dueDate ? ` on <strong>${appData.dueDate}</strong>` : ""}.</p>
                    <p>Please log in to your dashboard to complete the renewal process.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        },
        'renewal_reminder': {
            subject: `Renewal Reminder: ${appName} (GB-${appId})`,
            message: `Reminder: application ${appName} (GB-${appId}) is due for renewal${appData.dueDate ? ` on ${appData.dueDate}` : ""}.`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #17a2b8;">Renewal Reminder</h2>
                    <p>Dear ${userName},</p>
                    <p>This is a reminder that your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) is due for renewal${appData.dueDate ? ` on <strong>${appData.dueDate}</strong>` : ""}.</p>
                    <p>Please log in to your dashboard to complete the renewal process.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        },
        'initial_submission': {
            subject: `Initial Application Status: Registration as an ITL`,
            message: `An ITL application for Gaming licence GB-${appId} was submitted by ${userName} on ${submittedDate}`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #2c3e50;">Initial Application Status: Registration as an ITL</h2>
                    <p>Dear Admin,</p>
                    <p>An ITL application for Gaming licence <strong>GB-${appId}</strong> was submitted by <strong>${userName}</strong> on <strong>${submittedDate}</strong>.</p>
                    <p>The application is currently pending for review.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        },
        'certificate_created': {
            subject: `Certificate Issued: ${appName} (GB-${appId})`,
            message: `The certificate for application #GB-${appId} – ${appName} has been issued by the Gaming Board.`,
            html: `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #2c3e50;">Certificate Issued</h2>
                    <p>Dear ${userName},</p>
                    <p>The certificate for application <strong>#GB-${appId}</strong> – <strong>${appName}</strong> has been issued by the Gaming Board.</p>
                    <p>Please log in to your dashboard to view and download your certificate.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `
        }
    };

    // Support numeric mapped states
    const statusMap = {
        '1': 'in_process',
        '2': 'pending',
        '3': 'pending', // could be pending_for_approval
        '4': 'approved',
        '5': 'rejected',
        '6': 'discrepancies',
        '7': 'renewal',
        '8': 'drafts'
    };

    const finalStatus = statusMap[stateStr] || stateStr;
    return templates[finalStatus] || templates['in_process'];
};
